export default class ServiceResponse {
    constructor(succeeded, status, message, data) {
        this.succeeded = succeeded;
        this.status = status;
        this.message = message;
        this.data = data;
    }
}
